import React from "react"
import styled from "styled-components"

export const Container = styled.div`
  padding-right: 0.5rem;
`
export const Outer = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 1px 8px;
  gap: 10px;

  width: 40px;
  height: 22px;

  /* Sunset Orange / 1 */

  background: #fff7e6;
  /* Sunset Orange / 3 */

  border: 1px solid #ffd591;
  border-radius: 2px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
`

const Inner = styled.div`
  /* orange */

  width: 24px;
  height: 20px;

  /* Footnote/description */

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */

  /* Sunset Orange / 6 */

  color: #fa8c16;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
`
export const Required = () => {
  return (
    <Container>
      <Outer>
        <Inner>必須</Inner>
      </Outer>
    </Container>
  )
}
